import { isEmpty, find } from 'lodash';

export function getSharedPage(state) {
  return state.sharedPage;
}

export function isSolvedSharedPage(state) {
  return !isEmpty(state.sharedPageResults);
}

export function getSelectedSharedQuizOption(state) {
  return state.selectedOption;
}

export function getSharedPageResults(state) {
  return state.sharedPageResults;
}

export function getAnswerId(state, getters) {
  if (isEmpty(getters.getSharedPageResults)) return null;
  return getters.getSharedPageResults.answer_id;
}

export function getCorrectAnswerId(state, getters) {
  if (isEmpty(getters.getSharedPage)) return null;
  const correctAnswer = find(getters.getSharedPage.answers, { is_correct: true });
  return correctAnswer.id;
}

export function getSharedPageInfo(state) {
  return state.sharedPageInfo;
}
